import './assets/scss/theme.scss';
import './assets/scss/custom/table/datatables.scss';
import 'assets/css/sfStyles.css';
import "assets/css/customize_column_modal.css"

import {
  BrowserRouter as Router, Switch, useHistory,
} from 'react-router-dom';

import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  getAccount, getAccountCampaigns, getCampaignSpends, getCampaigns, getCurrentUser, getFilterPackages, getRoles, logoutUser, resetCopyScheduleToAllCampaigns, setCurrentRolePermissionsUIState
} from 'store/actions';
import { getSfFilters, getSourceTypes } from 'store/sf_common_data/actions';
import { getBrands } from 'store/brands/actions';
import { getAds } from 'store/creatives/actions';
import { getClickConversionPixels } from 'store/conversions/actions';
import { getAdminUserBannerMessages, getBannerMessages } from 'store/banner-messages/actions';
import { createLabelWithDateRange, createOption, DATE_RANGE_OPTIONS, DATE_RANGE_OPTIONS_DISPLAY } from 'components/Common/DateRangePicker';
import { AppContext, formatToISO, getCurrentBrandFromLocalStorage, getIANATimezoneStringForAbbreviation, handleSessionTimeOut, safeJSONParse, sfLog, subdomainApplications } from 'helpers/sf_utils';
import VerticalLayout from './components/VerticalLayout';
import NonAuthLayout from './components/NonAuthLayout';
import HorizontalLayout from './components/HorizontalLayout';
import Authmiddleware from './routes/route';
import { authProtectedRoutes, publicRoutes, adminPublicRoutes, adminUserAuthProtectedRoutes, fullWidthRoutes } from './routes';
import useExitPrompt from 'components/Common/useExitPrompt';
import { getRoleUIState } from 'helpers/sf_role_helper';
import { FEATURES } from 'pages/Roles/newFeaturesAndPermissionsData';
import { MODIFY_CAMPAIGN_SUCCESS, NEW_CAMPAIGN_SUCCESS } from 'store/campaign/actionTypes';
import { getFeaturesFlags } from 'store/admin/feature-flags/actions';
import { AppConfiguration } from 'config';
import useQuery from 'hooks/useQuery';
import { LOGIN_AS_USER_KEY, REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { bsh_isAdminUserDetailsPresent, bsh_setAdminUserDetails, bsh_setTokenForFilters, STORAGE_KEY, bsh_getTokenForFilters, bsh_getClientUserDetails, bsh_setInsuranceIoUserDetails, bsh_getFilters, bsh_getAdminUserDetails, bsh_getBothPrevAndCurrentAdminUserDetails, bsh_clearAdminUserDetails } from 'helpers/sf_browser_storage_helper';
import { getInsuranceCarriers } from 'store/insurance-carrier/actions';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { getAllAdminEmployees } from 'store/admin/admin-internal-user/actions';
import { getIntegrations, getSfLeadIntegrationMacroCategories, getSfLeadIntegrationMacros } from 'store/integration/actions';
import { getAdminInsuranceCarriers } from 'store/admin-insurance-carrier/actions';
import { getAdminUserNotificationPreferences } from 'store/admin/admin-notifications/actions';
import useClearableTimeout from 'hooks/useClearableTimeout';
import { createUserTermsOfService, getLatestTermsOfService } from 'store/terms-of-service/actions';
import { getAdminPaymentTerms } from 'store/admin-payment-terms/actions';
import PromptTermsOfServiceModal from 'pages/TermsOfServices/Modal/PromptTermsOfServiceModal';
import _ from 'lodash';
import { getPlatformSettings } from 'store/platform-settings/actions';
import usePlatformSettings from 'hooks/usePlatformSettings';
import { getWhitelistedBrands } from 'store/admin/whitelisted-brands/actions';
import { getAdminUserCurrentUser } from 'store/admin/Authentication/login/actions';
import { getAgentProfile } from 'store/quote_funnels/actions';
import ZipCodesContextProvider from 'contexts/zip_codes_context_provider';
import { getAdminRecentVisit } from 'store/admin/users/actions';
import { postAdminUserLogin } from 'store/admin/user-login/actions';
import useTabFocus from 'hooks/useTabFocus';
import jwtDecode from 'jwt-decode';
import { isInsuranceioBrand } from 'config';
import { isGoalBrand } from 'config';
import { getCampaignStickyColumns } from 'store/user_column_preference/campaign-sticky-columns/actions';
import { getAdgroupStickyColumns } from 'store/user_column_preference/adgroup-sticky-columns/actions';
import { getCallSourceSettingStickyColumns, getLeadSourceSettingStickyColumns, getSourceSettingStickyColumns } from 'store/user_column_preference/source-setting-sticky-columns/actions';
import { getLeadProfileStickyColumns } from 'store/user_column_preference/lead-profile-sticky-columns/actions';
import { getCallProfileStickyColumns } from 'store/user_column_preference/call-profile-sticky-columns/actions';
import { getLeadStickyColumns } from 'store/user_column_preference/lead-sticky-columns/actions';
import { getProspectStickyColumns } from 'store/prospects/prospects_customize_columns';
import { getCallStickyColumns } from 'store/user_column_preference/call-sticky-columns/actions';
import { getCallsDashboardCampaignsStickyColumns, getCallsDashboardStatesStickyColumns } from 'store/user_column_preference/calls-dashboard-sticky-columns/actions';
import { getClicksDashboardStickyColumns } from 'store/user_column_preference/clicks-dashboard-sticky-column/actions';
import { getSyndiClicksDashboardStickyColumns } from 'store/user_column_preference/syndi-clicks-dashboard-sticky-column/actions';
import { getLeadsDashboardStickyColumns } from 'store/user_column_preference/leads-dashboard-sticky-column/actions';
import { getConversionLogStickyColumns } from 'store/user_column_preference/conversion-log-sticky-columns/actions';
import { getAnalyticsStickyColumns } from 'store/user_column_preference/analytics-sticky-columns/actions';
import { getLeadPrices } from 'store/lead_prices/actions';
import { getQuoteFunnelsPrices } from 'store/quote_funnels_prices/actions';
import { getCallPrices } from 'store/call_prices/actions';
import { getApiToken } from 'store/api-tokens/actions';
import { getLeadRefundReasons } from 'store/leads/lead_refund_reasons_actions';
import { getZipTiers } from 'store/zip_tiers/actions';

const CAMPAIGN_FILTERS = {
  STATUS: 'status',
  PRODUCT: 'product',
  LEAD_TYPE: 'lead_type',
  CAMPAIGN_NAME: 'campaign_name',
  DATE_RANGE: 'date_range',
}

function App(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isFeatureFlagActive, areFeatureFlagsLoaded] = useFeatureFlags();
  const [showExitPrompt, setShowExitPrompt] = useExitPrompt(false);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);

  const query = useQuery();
  const { isClicksProductEnabled, isMetricsEnabled, isPixelConversionSettingsEnabled, isProfilesEnabled, isSourceSettingsEnabled } = usePlatformSettings();
  const adminAccess = query.get('admin_access');
  const accessUserToken = query.get('access_user_token');
  const accessAdminToken = query.get(LOGIN_AS_USER_KEY.ACCESS_ADMIN_TOKEN);
  const accessInsuranceIoToken = query.get(LOGIN_AS_USER_KEY.ACCESS_INSURANCE_IO_TOKEN);
  const [reloadTimeoutSet] = useClearableTimeout();

  useEffect(() => {
    if (accessUserToken) {      //when we login into client account from admin account - accessAdminToken is admin user's token and accessUserToken is client user's token
      localStorage.setItem("authUser", accessUserToken);
      adminAccess != null && localStorage.setItem("adminAccess", adminAccess);
      localStorage.removeItem("current_brand");
      bsh_setAdminUserDetails({ token: accessAdminToken });
      bsh_setInsuranceIoUserDetails({ token: accessInsuranceIoToken });
    }
  }, [accessUserToken]);

  useEffect(() => {
    if (bsh_isAdminUserDetailsPresent()) {
      dispatch(getAdminUserBannerMessages());
      dispatch(getAdminUserCurrentUser());
    }
  }, [])

  useEffect(() => {
    // APIs used only in admin portal 
    if (bsh_isAdminUserDetailsPresent() && areFeatureFlagsLoaded &&
      (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REDUCE_APP_INITIAL_LOAD_API) || isAdminPortal)) {
      dispatch(getAdminInsuranceCarriers());
      dispatch(getAdminPaymentTerms());
    }
  }, [areFeatureFlagsLoaded])

  //TODO: Refactor
  const {
    current_user, error, current_account, current_brand,
    error_campaigns, error_ads, roles,
    current_role_permissions_state,
    copy_schedule_to_all_campaign,
    lastCompletedAction, current_admin_user_permissions,
    current_admin_user,
    reload_required,
    latest_terms_of_service,
  } = useSelector((state) => ({
    current_user: state.Login.current_user,
    current_admin_user: state.LoginAdminUser.current_user,
    current_admin_user_permissions: state.LoginAdminUser.current_admin_user_permissions,
    error: state.Login.error,
    current_account: state.accounts.current_account,
    current_brand: state.Brands.current_brand,
    source_types: state.SfCommonData.source_types,
    banner_messages: state.BannerMessages.banner_messages,
    error_campaigns: state.Campaign.error,
    error_ads: state.Ads.error,
    roles: state.Role.roles,
    current_role_permissions_state: state.Role.current_role_permissions_state,
    copy_schedule_to_all_campaign: state.Campaign.copy_schedule_to_all_campaign,
    lastCompletedAction: state.Campaign.lastCompletedAction,
    click_campaign_stats: state.Campaign.click_campaign_stats,
    lead_campaign_stats: state.Campaign.lead_campaign_stats,
    call_campaign_stats: state.Campaign.call_campaign_stats,
    reload_required: state.LoginAdminUser.reload_required,
    latest_terms_of_service: state.TermsOfServices.latest_terms_of_service,
    click_campaign_stats_loading: state.Campaign.click_campaign_stats_loading,
    lead_campaign_stats_loading: state.Campaign.lead_campaign_stats_loading,
    call_campaign_stats_loading: state.Campaign.call_campaign_stats_loading,
  }));

  const [showTermsOfServiceModal, setShowTermsOfServiceModal] = useState({ isActive: false, terms_of_service: null });

  useEffect(() => {
    if (current_account && latest_terms_of_service) {
      if (!bsh_isAdminUserDetailsPresent() && isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_TERMS_OF_SERVICES_IN_CLIENT_VIEW)) {
        if (current_account?.terms_of_service_id !== latest_terms_of_service?.id) {
          setShowTermsOfServiceModal({ isActive: true, terms_of_service: latest_terms_of_service });
        }
      }
    }
  }, [current_account, latest_terms_of_service]);

  const hasFocus = useTabFocus();

  useEffect(() => {
    const account_id_from_local_storage = safeJSONParse(localStorage.getItem('authUser'), null)?.user?.account_id
    if (current_account?.id && account_id_from_local_storage && hasFocus && account_id_from_local_storage != current_account?.id) {
      const params = new URLSearchParams(location.search);
      params.set('account_id', account_id_from_local_storage);
      const brand_id_from_local_storage = getCurrentBrandFromLocalStorage()?.id
      if (!brand_id_from_local_storage) {
        params.delete('brand_id');
      } else {
        params.set('brand_id', brand_id_from_local_storage);
      }
      params.delete('filters');

      const updatedUrl = `${location.pathname}?${params.toString()}`;

      const hostParts = window.location.host;
      const redirect_url = `http://${hostParts}${updatedUrl}`
      window.location.replace(redirect_url);
    }
  }, [current_account, hasFocus, current_brand])

  useEffect(() => {
    if (_.isEqual(bsh_getClientUserDetails(), bsh_getTokenForFilters())) {
      return;
    } else {
      localStorage.removeItem(STORAGE_KEY.FILTERS.NAME)
      bsh_setTokenForFilters(bsh_getClientUserDetails())
    }
  }, [localStorage.getItem('authUser')]);

  const selectedDateRange = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const decodedFilters = searchParams.get('filters');

    let dateRange = null;
    if (decodedFilters) {
      let parsedFilters = JSON.parse(decodeURIComponent(decodedFilters));
      if (parsedFilters?.filters) {
        parsedFilters = parsedFilters?.filters
      }

      //checks if parsedFilters is iterable
      if (typeof parsedFilters[Symbol.iterator] === 'function') {
        for (const param of parsedFilters) {
          const { name, value } = param;
          const decodedKey = decodeURIComponent(name);
          const decodedValue = typeof value === 'object' ? value : decodeURIComponent(value);

          if (decodedKey === CAMPAIGN_FILTERS.DATE_RANGE) {
            if (decodedValue?.startDate && decodedValue?.endDate) {
              const startDate = new Date(decodedValue?.startDate);
              const endDate = new Date(decodedValue?.endDate);
              dateRange = {
                label: createLabelWithDateRange({ label: DATE_RANGE_OPTIONS_DISPLAY.CUSTOM_RANGE, startDate, endDate }),
                value: {
                  startDate: startDate?.toISOString(),
                  endDate: endDate?.toISOString()
                },
                original_label: DATE_RANGE_OPTIONS.CUSTOM_RANGE,
                timezone: getIANATimezoneStringForAbbreviation(current_account?.timezone)
              };
            }
            else {
              dateRange = createOption(
                decodedValue,
                new Date(),
                getIANATimezoneStringForAbbreviation(current_account?.timezone)
              );
            }
          }
        }
      }

    } else if (bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.DATE_RANGE)) {
      return bsh_getFilters(STORAGE_KEY.FILTERS.CAMPAIGN, CAMPAIGN_FILTERS.DATE_RANGE)
    }
    else {
      dateRange = createOption(
        DATE_RANGE_OPTIONS.THIS_MONTH,
        new Date(),
        getIANATimezoneStringForAbbreviation(current_account?.timezone)
      );
    }

    return dateRange;
  }, [current_account?.timezone]);


  useEffect(() => {
    if (!localStorage.getItem('authUser')) {
      return;
    }
    dispatch(getCurrentUser(history));
  }, []);

  //Remove tokens from localstorage and redirect user to login
  const removeTokenAndNavigate = () => {
    bsh_clearAdminUserDetails()
    localStorage.removeItem('authUser');
    localStorage.removeItem('prevAuthAdminUser');
    localStorage.removeItem('insurance_io_user_token');
    localStorage.removeItem('insurance_carrier');
    window.location.replace('/login?session_expired=1')
  };

  //Checks for the token and set a timeout if the token is not currently exprired

  function handleAuthToken() {
    //Fetching the tokens again as the tokens might have been updated
    const authAdminToken = bsh_getAdminUserDetails()?.token;
    const authUserToken = bsh_getClientUserDetails()?.token;
    const prevAuthAdminToken = bsh_getBothPrevAndCurrentAdminUserDetails()?.prev_token
    try {
      const decodedToken = jwtDecode(prevAuthAdminToken ? prevAuthAdminToken : ((authUserToken && !authAdminToken) ? authUserToken : authAdminToken));
      const currentTime = Date.now();
      const timeUntilExpiry = decodedToken.exp * 1000 - currentTime;
      if (timeUntilExpiry <= 0) {
        removeTokenAndNavigate();
      }
    } catch (error) {
      sfLog("Error while decoding token: ", error);
    }
  }

  function recursiveAuthCheck() {
    handleAuthToken();
    setTimeout(recursiveAuthCheck, 3000);
  }

  useEffect(() => {
    if (reload_required) {
      const hostParts = window.location.host;
      const redirect_url = `http://${hostParts}/dashboard`;
      reloadTimeoutSet(() => {
        window.location.replace(redirect_url);
      }, 1000)
    }
  }, [reload_required])

  useEffect(() => {
    // APIs used only in admin portal
    if (current_admin_user && areFeatureFlagsLoaded &&
      (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REDUCE_APP_INITIAL_LOAD_API) || isAdminPortal)) {
      dispatch(getAllAdminEmployees());
      dispatch(getWhitelistedBrands())
      dispatch(getAdminRecentVisit())
      if (current_admin_user?.admin_role?.admin_notification_template &&
        isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ADMIN_ACCOUNT_NOTIFICATIONS)) {
        dispatch(getAdminUserNotificationPreferences());
      }
    }
  }, [current_admin_user, areFeatureFlagsLoaded]);

  useEffect(() => {
    if (current_user) {
      // Call the APIs here which can be called after current_user is set
      dispatch(getAccount());
      dispatch(getLatestTermsOfService());
    }
  }, [current_user]);

  useEffect(() => {
    if (current_user && current_account) {
      // Call the APIs here which can be called AFTER both current_user and
      // current_account are set
      dispatch(getSfFilters());
      dispatch(getBrands());
      dispatch(getPlatformSettings());
      dispatch(getBannerMessages());
      dispatch(getRoles());
      dispatch(getAccountCampaigns());
    }
  }, [current_user, current_account]);

  // V1 lead integrations fallback. Gated behind areFeatureFlagsLoaded so a late-arriving
  // flag map does not momentarily evaluate to "V2 off" and fire the V1 API unnecessarily.
  useEffect(() => {
    if (current_user && current_account && areFeatureFlagsLoaded) {
      if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_LEAD_INTEGRATIONS_V2_OPTIMIZATION)) {
        dispatch(getIntegrations());
      }
    }
  }, [current_user, current_account, areFeatureFlagsLoaded]);

  useEffect(() => {
    if (current_user && current_account && areFeatureFlagsLoaded) {
      if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REDUCE_APP_INITIAL_LOAD_API)) {
        dispatch(getSourceTypes());
        dispatch(getCampaignStickyColumns());
        dispatch(getAdgroupStickyColumns());
        dispatch(getSourceSettingStickyColumns());
        dispatch(getLeadSourceSettingStickyColumns());
        dispatch(getCallSourceSettingStickyColumns());
        dispatch(getLeadProfileStickyColumns());
        dispatch(getCallProfileStickyColumns());
        dispatch(getLeadStickyColumns())
        dispatch(getProspectStickyColumns())
        dispatch(getCallStickyColumns())
        dispatch(getCallsDashboardStatesStickyColumns())
        dispatch(getCallsDashboardCampaignsStickyColumns())
        dispatch(getClicksDashboardStickyColumns())
        dispatch(getSyndiClicksDashboardStickyColumns())
        dispatch(getLeadsDashboardStickyColumns())
        dispatch(getConversionLogStickyColumns())
        dispatch(getAnalyticsStickyColumns())
        dispatch(getLeadPrices());
        isGoalBrand && dispatch(getQuoteFunnelsPrices());
        dispatch(getCallPrices())
        dispatch(getApiToken());
        dispatch(getSfLeadIntegrationMacros());
        dispatch(getLeadRefundReasons())
        dispatch(getSfLeadIntegrationMacroCategories())
        dispatch(getFilterPackages());
        dispatch(getZipTiers())
      }
    }
  }, [current_user, current_account, areFeatureFlagsLoaded]);

  useEffect(() => {
    dispatch(getFeaturesFlags());
    dispatch(getInsuranceCarriers());
    recursiveAuthCheck()
  }, []);

  useEffect(() => {
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ADD_GOOGLE_API_SCRIPT)) {
      const element = document.getElementById('google-api-script');
      if (!element) {
        const script = document.createElement('script');
        const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
        if (apiKey) {
          const url = "https://maps.googleapis.com/maps/api/js"
          script.id = 'google-api-script'
          script.src = url + `?key=${apiKey}&libraries=places`;
          script.async = true;
          document.head.appendChild(script);
        }
      }
    }
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CAPTURE_SESSION) && isInsuranceioBrand) {
      var s = document.createElement('script');
      s.id = 'xxConsentConfirmationxx';
      if (document.getElementById('xxConsentConfirmationxx')) {
        return;
      }
      s.type = 'text/javascript';
      s.async = true;
      s.src = "https://stage.d1jglqbe79y3fo.amplifyapp.com/bundle-stage.js";
      var ss = document.getElementsByTagName('script')[0];
      ss.parentNode.insertBefore(s, ss);
      window.xxConsentConfirmationTokenxx = '6036f4f803454cb9946fbfcedaee6b3a';
    }
  }, [isFeatureFlagActive])

  //if admin is logged in to some account and then clicks on url which is of some other account
  // then he will be redirected to the latest one
  const url_filters = window.location.pathname + window.location.search
  const urlParams = new URLSearchParams(url_filters);
  let accountIdFromUrl = urlParams.get('account_id');

  useEffect(() => {
    if (current_account && accountIdFromUrl && (current_account?.id != accountIdFromUrl)) {
      dispatch(postAdminUserLogin({ user: { account: accountIdFromUrl }, history: history }, url_filters))
    }
  }, [current_account, accountIdFromUrl])

  useEffect(() => {
    if (!roles?.data || !current_user) {
      dispatch(setCurrentRolePermissionsUIState(null));
      return;
    }

    const current_user_role_id = current_user.memberships[0]?.role?.id;
    if (!current_user_role_id) return;

    const current_role = roles.data.find(role => role.id === current_user_role_id);
    if (!current_role) return;

    const rolePermissionsUIState = getRoleUIState(current_role, [...FEATURES]).map(feature => feature.permissions).flat();
    dispatch(setCurrentRolePermissionsUIState(rolePermissionsUIState));
  }, [roles, current_user])

  useEffect(() => {
    if (current_brand && current_account?.timezone) {
      dispatch(getAgentProfile())
      const queryParams = {};
      const dateRangeValue = _.cloneDeep(selectedDateRange?.value);
      const startISO = formatToISO(dateRangeValue?.startDate);
      const endISO = formatToISO(dateRangeValue?.endDate);
      if (startISO) queryParams.start_date = startISO;
      if (endISO) queryParams.end_date = endISO;

      dispatch(getCampaigns({ queryParams, time_frame_key: selectedDateRange?.original_label }));
      dispatch(getAds({ queryParams }));
      dispatch(getClickConversionPixels());
      dispatch(getCampaignSpends({ queryParams, time_frame_key: selectedDateRange?.original_label }))
    }
  }, [dispatch, current_brand, current_account?.timezone]);

  const getAllCampaigns = () => {
    const queryParams = {};
    const dateRangeValue = _.cloneDeep(selectedDateRange?.value);
    const startISO = formatToISO(dateRangeValue?.startDate);
    const endISO = formatToISO(dateRangeValue?.endDate);
    if (startISO) queryParams.start_date = startISO;
    if (endISO) queryParams.end_date = endISO;

    dispatch(getCampaigns({ queryParams, time_frame_key: selectedDateRange?.original_label }));
  }

  useEffect(() => {
    if ([MODIFY_CAMPAIGN_SUCCESS, NEW_CAMPAIGN_SUCCESS].includes(lastCompletedAction) && copy_schedule_to_all_campaign) {
      getAllCampaigns();
      dispatch(resetCopyScheduleToAllCampaigns());
    }
  }, [lastCompletedAction])

  useEffect(
    () => handleSessionTimeOut(error, history),
    [error],
  );
  useEffect(
    () => handleSessionTimeOut(error_campaigns, history),
    [error_campaigns],
  );
  useEffect(
    () => handleSessionTimeOut(error_ads, history),
    [error_ads],
  );

  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case 'horizontal':
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  const public_routes = publicRoutes.map((route, idx) => (
    <Authmiddleware
      path={route.path}
      layout={NonAuthLayout}
      component={route.component}
      key={`client-public-${idx}`}
      loading={false}
      isAuthProtected={false}
      exact
    />
  ))

  const full_width_routes = fullWidthRoutes.map((route, idx) => (
    <Authmiddleware
      path={route.path}
      layout={NonAuthLayout}
      component={route.component}
      key={`client-full-width-protected-${idx}`}
      loading={!current_account}
      rolePermissions={current_role_permissions_state}
      currentAccount={current_account}
      isPlatformSettingFeatures={{ isClicksProductEnabled, isMetricsEnabled, isPixelConversionSettingsEnabled, isProfilesEnabled, isSourceSettingsEnabled }}
      isAuthProtected={true}
      exact
    />
  ))

  const auth_protected_routes = authProtectedRoutes.map((route, idx) => (
    <Authmiddleware
      path={route.path}
      layout={Layout}
      component={route.component}
      key={`client-protected-${idx}`}
      loading={!current_account}
      rolePermissions={current_role_permissions_state}
      currentAccount={current_account}
      isPlatformSettingFeatures={{ isClicksProductEnabled, isMetricsEnabled, isPixelConversionSettingsEnabled, isProfilesEnabled, isSourceSettingsEnabled }}
      isAuthProtected={true}
      exact
    />
  ))

  const admin_public_routes = adminPublicRoutes.map((route, idx) => (
    <Authmiddleware
      path={route.path}
      layout={NonAuthLayout}
      component={route.component}
      key={`admin-public-${idx}`}
      loading={false}
      isAuthProtected={false}
      exact
    />
  ))

  const auth_admin_routes = adminUserAuthProtectedRoutes.map((route, idx) => (
    <Authmiddleware
      path={route.path}
      layout={Layout}
      component={route.component}
      key={`admin-protected-${idx}`}
      loading={false}
      isAuthProtected={true}
      adminRolePermissions={(current_admin_user && current_admin_user_permissions) || null}
      exact
    />
  ))

  const getHostApp = subdomainApplications([
    {
      subdomains: [AppConfiguration.REACT_CLIENT_HOST_SUBDOMAIN],
      application: function () {
        return [...public_routes, ...full_width_routes, ...auth_protected_routes];
      },
      main: true
    },
    {
      subdomains: [AppConfiguration.REACT_ADMIN_HOST_SUBDOMAIN],
      application: function () {
        return [...admin_public_routes, ...auth_admin_routes];
      }
    }
  ]);

  const onCloseClick = () => {
    setShowTermsOfServiceModal({ isActive: false, terms_of_service: null });
    dispatch(logoutUser(history));
  }

  const onClickAcceptTermOfService = (terms_of_service) => {
    const user_tos_data = {
      terms_of_service_id: terms_of_service?.id,
      name: terms_of_service?.name,
      url: terms_of_service?.url,
      accepted_by: current_user?.id
    }

    dispatch(createUserTermsOfService(user_tos_data))
    setShowTermsOfServiceModal({ isActive: false, terms_of_service: null });
  }

  const { app: HostApp, is_admin: isAdminPortal } = getHostApp();

  return (
    <AppContext.Provider value={{ showExitPrompt, setShowExitPrompt, isSidebarMinimized, setIsSidebarMinimized }}>
      <ZipCodesContextProvider>
        {showTermsOfServiceModal?.isActive && (<PromptTermsOfServiceModal
          termsOfService={showTermsOfServiceModal}
          onCloseClick={onCloseClick}
          onAcceptClick={onClickAcceptTermOfService}
        />)}
        <Router>
          <Switch>
            {HostApp()}
          </Switch>
        </Router>
      </ZipCodesContextProvider>
    </AppContext.Provider>
  );
}

App.propTypes = {
  layout: PropTypes.any,
  location: PropTypes.any,
};

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

export default connect(mapStateToProps, null)(App);
